<template>
	<v-app>
		<div class="background-img" v-resize="onResize">
			<!-- Toolbar -->
			<v-toolbar dense class="toolbar-top" height="70px">
				<v-toolbar-title class="toolbar-title">
					<v-app-bar-nav-icon v-if="windowSize.x > 1263" @click="sidebar = !sidebar"></v-app-bar-nav-icon>
					<v-row no-gutters class="toolbar-row">
						<v-col cols="auto" md="auto" lg="auto" align-self="center" class="pr-3 ml-1">
							<v-avatar v-if="windowSize.x > 512" size="35" color="#FFF9C4">
								<img src="/new-logo.png" alt="logo">
							</v-avatar>
						</v-col>
						<v-col cols="10" md="" lg="" align-self="center">
							<v-row class="toolbar-row">
								<b class="toolbar-organization-name text-truncate">ระบบลงทะเบียนผู้ผ่านการฝึกอบรม
									และเปลี่ยนผ่าน/เทียบเท่า</b>
							</v-row>
							<v-row class="mt-0 toolbar-row">
								<span class="toolbar-organization-province">สถาบันการแพทย์ฉุกเฉินแห่งชาติ</span>
							</v-row>
						</v-col>
					</v-row>
					<div class="pl-2 pr-2 profile-user">
						<div no-gutters class="standard-row ml-2">
							<v-row no-gutters class="standard-row d-flex justify-center"
								style="color: rgb(60,86,147); font-size: 14px; font-weight: 600;">
								{{ training_organization_name }}
							</v-row>
							<v-row no-gutters class="standard-row d-flex justify-center"
								style="color: rgb(60,86,147); font-size: 12px; font-weight: 300;">
								{{ province }}
							</v-row>
						</div>
					</div>
					<v-btn color="#ffffff" class="toolbar-logout-btn" @click="logout">
						<v-icon>mdi-export</v-icon>
						<!-- <span>ออกจากระบบ</span> -->
					</v-btn>
				</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<!-- Sidebar -->
			<v-navigation-drawer v-model="sidebar" app class="navigation-drawer ">
				<v-row class="pt-5 justify-center align-center">
					<v-avatar size="85" color="#ffffff">
						<img width="85" height="85" src="/new-hospital.png"
							style="object-fit: contain" alt="icon hospital">
					</v-avatar>
				</v-row>
				<v-row class="pt-5 justify-center align-center">
					<b class="text-sidebar">{{ training_organization_name }}</b>
				</v-row>
				<v-row class="mt-3 mb-4 justify-center align-center">
					<span class="text-sidebar-2">{{ province }}</span>
				</v-row>
				<v-divider style="border: none;"></v-divider>
				<v-list dense style="padding: 5px;" class="list-sub-menu">
					<v-list-item :class="{ 'selected-item': $route.path === item.link }"
						v-for="(item, index) in filteredMenuItem" :key="index" @click="sendData(item.link)">
						<v-icon :class="{ 'icon-sidebar': true, 'icon-selected': $route.path === item.link }"
							class="mr-3">
							{{ item.icon }}
						</v-icon>
						<v-list-item-title class="font-navigation-drawer">{{ item.text }}</v-list-item-title>
					</v-list-item>
					<v-list-group :value="true">
						<template #activator>
							<v-list-item>
								<v-icon class="icon-sidebar mr-4">
									mdi-tab-plus</v-icon>
								<v-list-item-title class="font-navigation-drawer-sub pl-0">
									ข้อมูลบันทึกการลงทะเบียนเจ้าหน้าที่ขององค์กรย้อนหลัง
								</v-list-item-title>
							</v-list-item>
						</template>
						<v-list-item class="ml-2 mr-2" @click="saveSystem('1')"
							:class="{ 'selected-item': stepNumber === '1' && $route.path === '/save_log_register_list' }">
							<v-icon
								:class="{ 'icon-sidebar': true, 'icon-selected': stepNumber === '1' && $route.path === '/save_log_register_list' }"
								class="mr-3">
								mdi-order-bool-descending-variant</v-icon>
							<v-list-item-title class="font-navigation-drawer pl-0">
								ระบบลงทะเบียนผู้ผ่านการฝึกอบรม และผ่านการประเมินและสอบ
							</v-list-item-title>
						</v-list-item>
						<v-list-item class="ml-2 mr-2" @click="saveSystem('2')"
							:class="{ 'selected-item': stepNumber === '2' && $route.path === '/save_log_register_list' }">
							<v-icon
								:class="{ 'icon-sidebar': true, 'icon-selected': stepNumber === '2' && $route.path === '/save_log_register_list' }"
								class="mr-3">
								mdi-certificate</v-icon>
							<v-list-item-title class="font-navigation-drawer pl-0">
								ระบบลงทะเบียนผู้สำเร็จการอบรมหลักสูตรเปลี่ยนผ่าน/เทียบเท่า
							</v-list-item-title>
						</v-list-item>
					</v-list-group>
				</v-list>
			</v-navigation-drawer>
			<!-- Main Content -->
			<v-main class="pt-0 pb-0 pl-0 pr-0">
				<v-container fluid class="pa-3">
					<SelectSystemModal />
					<router-view />
				</v-container>
			</v-main>
		</div>
	</v-app>
</template>
<script>
import { EventBus } from '../EventBus';
import SelectSystemModal from '../components/SelectSystemModal.vue'
export default {
	components: {
		SelectSystemModal
	},
	data: () => ({
		training_organization_name: '',
		province: '',
		sidebar: false,
		windowSize: { x: 0 },
		filteredMenuItem: {},
		stepNumber: '',
		menuItems: [
			{ text: "ระบบลงทะเบียนผู้ผ่านการฝึกอบรม และผ่านการประเมินและสอบ", icon: "mdi-order-bool-descending-variant", link: "/registration/get_cert_form", userOnly: true },
			{ text: "ระบบลงทะเบียนผู้สำเร็จการอบรมหลักสูตรเปลี่ยนผ่าน/เทียบเท่า", icon: "mdi-certificate", link: "/registration/guarantee_form", userOnly: true },
			{ text: "ระบบออกประกาศนียบัตรผู้ปฏิบัติการตามรอบ", icon: "mdi-card-account-details", link: "/generate_certificated", userOnly: false },
			{ text: "บันทึกข้อมูลประกาศนียบัตรของผู้ปฏิบัติการ", icon: "mdi-book-plus-outline", link: "/add_certificate_form", userOnly: false },
			{ text: "ระบบออกบัตรประจำตัวผู้ปฏิบัติการ", icon: "mdi-id-card", link: "/id_card_form", userOnly: false }
		],
	}),
	watch: {
		sidebar(newValue) {
			sessionStorage.StatusSidebar = JSON.stringify(newValue)
			EventBus.$emit('sidebarChanged', newValue);
		},
		'$route.path': function (newPath) {
			if (newPath === '/registration') {
				this.sidebar = false;
			}else{
				this.sidebar = true;
			}
		}
	},
	mounted() {
		this.onResize()
		sessionStorage.StatusSidebar = false;
		const userProfile = JSON.parse(sessionStorage.userProfile)
		this.is_admin = userProfile.is_admin || false;
		const { training_organization_name, province } = JSON.parse(sessionStorage.userProfile)
		this.training_organization_name = training_organization_name
		this.province = province
		this.filteredMenuItems()
		EventBus.$on('offToolbar', (step) => {
			this.stepNumber = step 
		
		if (this.$route.path === '/registration') {
		this.sidebar = false
		} else {
		this.sidebar = true
		}
	})
	},
	destroyed() {
		EventBus.$off('offToolbar');
	},
	methods: {
		logout() {
			sessionStorage.clear()
			this.$apiConfig.setToken(null)
			this.$router.replace({ name: 'login' })
		},
		openSelectSystem() {
			EventBus.$emit('openSelectSystemModal')
			this.sidebar = false;
		},
		filteredMenuItems() {
			if (this.is_admin == true) {
				this.filteredMenuItem = this.menuItems;
			} else {
				this.filteredMenuItem = this.menuItems.filter(item => item.userOnly == true);
			}
		},
		saveSystem(step) {
			this.stepNumber = step
			sessionStorage.setItem('system', step);    		
			if (this.$route.path !== "/save_log_register_list") {
				this.$router.push("/save_log_register_list");
			} else {
				EventBus.$emit('reloadGetData')
			}
		},
		sendData(action) {
			this.$router.push(action);
			this.sidebar = false;
		},
		onResize() {
			this.windowSize = { x: window.innerWidth };
		},
	}
}
</script>

<style>
.toolbar-top {
	box-shadow: none !important;
	background-color: #F5FBFD !important;
	position: sticky;
	top: 0px;
	/* z-index: 1000; */
	z-index: 1;
}

.toolbar-top-radius {
	background-color: #ffffff !important;
}

.toolbar-icon-name {
	width: 100%;
}

.toolbar-row {
	width: 100%;
	margin: 0%;
}

.toolbar-organization-name {
	font-family: 'Noto Sans Thai', sans-serif;
	color: rgba(27, 87, 126, 1);
	font-size: 18px;
}

.toolbar-organization-province {
	font-family: 'Noto Sans Thai', sans-serif;
	color: rgba(27, 87, 126, 1);
	font-size: 13px;
	font-weight: 700;
	line-height: 17px;
}

.toolbar-logout-btn {
	box-shadow: none !important;
	border-radius: 8px;
	font-family: 'Noto Sans Thai', sans-serif;
	color: rgb(60, 86, 147) !important;
	font-size: 13px !important;
	font-weight: 700 !important;
	height: 35px !important;
	width: 40px !important;
}

.toolbar-title {
	display: flex;
	padding: 5px;
	border-radius: 12px;
	background-color: #ffffff;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.selected-item-2 {
	background-color: #ffffff !important;
	color: #1B577E !important;
}

.navigation-drawer {
	border-radius: 12px;
	background: url("/imageBg.png"),
		linear-gradient(354deg, rgba(64, 156, 214, 0.8) 25.44%, rgba(27, 87, 126, 0.8) 161.68%);
	background-size: contain;
	background-position: bottom right;
	background-repeat: no-repeat;
	height: 100vh;
	margin: 5px;
	padding-top: 40px;
	max-height: calc(100% - 10px) !important;
	transform: translateX(0%);
	width: 256px;
}

.text-sidebar {
	font-family: 'Noto Sans Thai', sans-serif;
	color: #ffffff;
	font-size: 16px !important;
	white-space: normal;
	/* ขึ้นบรรทัดใหม่ */
	word-break: break-word;
	/* ตัดคำเมื่อความยาวเกิน */
}

.text-sidebar-2 {
	font-family: 'Noto Sans Thai', sans-serif;
	color: #ffffff;
	font-size: 12px !important;
	white-space: normal;
	/* ขึ้นบรรทัดใหม่ */
	word-break: break-word;
	/* ตัดคำเมื่อความยาวเกิน */
}

.font-navigation-drawer {
	font-family: 'Noto Sans Thai', sans-serif;
	color: #ffffff;
	margin: 6px;
	font-size: 14px !important;
	font-weight: 500 !important;
	white-space: normal;
	/* ขึ้นบรรทัดใหม่ */
	word-break: break-word;
	/* ตัดคำเมื่อความยาวเกิน */
}

.font-navigation-drawer-sub {
	font-family: 'Noto Sans Thai', sans-serif;
	color: #ffffff;
	font-size: 14px !important;
	font-weight: 500 !important;
	white-space: normal;
	/* ขึ้นบรรทัดใหม่ */
	word-break: break-word;
	/* ตัดคำเมื่อความยาวเกิน */
}

.v-navigation-drawer .v-list .v-list-item--active .font-navigation-drawer {
	color: #1B577E !important;

}

.selected-item .navigation-drawer .v-list .v-list-item--active {
	background-color: #ffffff;
}

.selected-item .font-navigation-drawer {
	color: #1B577E;
}

.selected-item {
	padding-left: 6px !important;
	padding-right: 5px !important;
	background-color: #f0f0f0;
}

.selected-item-sub {
	padding-left: 6px !important;
	padding-right: 5px !important;
}

.navigation-drawer .v-icon.v-icon::after {
	background-color: #1B577E;
}
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0px;
}
.icon-sidebar {
	font-size: 20px !important;
	color: #ffffff !important;
}

.icon-sidebar .v-list-item--dense .v-list-item__icon,
.v-list--dense .v-list-item .v-list-item__icon {
	margin-right: 5px !important;
}

.v-list-item {
	padding: 2px;
}

.icon-selected {
	color: #1B577E !important;
}

.v-application {
	background-color: #F5FBFD !important;
}

.v-list-item__content {
	font-family: 'Noto Sans Thai', sans-serif !important;
}

.close-btn {
	position: absolute;
	top: 10px;
	right: 10px;
	color: #ffffff !important;
}

.scrollbar-history-budget-dashboard-tab {
	overflow-y: auto;
	max-height: calc(100vh - 119px);
	scroll-behavior: smooth;
}

.scrollbar-history-budget-dashboard-tab::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

.scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb {
	background-color: #F0F0F0;
}

.scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb:hover {
	background-color: #D9D9D9;
}

.profile-user {
	box-shadow: 0px 0.5px 2px 0px rgba(96, 97, 112, 0.16),
	0px 0px 1px 0px rgba(40, 41, 61, 0.08);
	background: rgb(255, 255, 255) !important;
	margin: 6px;
	font-family: 'Noto Sans Thai', sans-serif !important;
	border-radius: 6px;
}

.list-sub-menu .v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
	color: white;
}

.list-sub-menu .v-icon.v-icon {
	color: white;
}
/*========================================*/

@media only screen and (max-width:600px) {

	/* css for mobile */
	.toolbar-organization-name {
		font-size: 15px;
	}
}
</style>